import React from "react";

import "./book-review-button.m.css";
import { BOOK_REVIEW_TITLE } from "../../../constants";

const BookReviewButton = () => {
  return (
    <div styleName="book-review-button" className="book-review-button">
      {BOOK_REVIEW_TITLE}
    </div>
  );
};

export default BookReviewButton;
